export default __webpack_public_path__ + "static/media/showEye.20e42da9.svg";